/* eslint-disable complexity */
import { Theme } from '@mui/material/styles';
import { SxProps, darken } from '@mui/system';
import { Colors } from '../../constants/colors.constants';
import { ButtonColors } from './button.component';

export const defaultButtonStyles = (
	variant?: string,
	options: ButtonColors = {},
	strictColor = false,
	transparent = false
): SxProps<Theme> => {
	const {
		fontColor = variant === 'secondary' ? Colors.white : Colors.black,
		hoverFontColor = variant === 'secondary' ? Colors.black : Colors.white,
		backgroundColor = variant === 'secondary' ? Colors.black : Colors.white,
		hoverBackgroundColor = variant === 'secondary' ? Colors.white : Colors.black,
		activeFontColor = hoverFontColor,
		activeBackgroundColor = hoverBackgroundColor,
	} = options;

	const borderColor = transparent ? Colors.white : variant === 'secondary' ? Colors.white : Colors.white;

	return {
		backgroundColor: transparent ? 'transparent' : backgroundColor,
		color: transparent ? Colors.white : fontColor,
		border: `1px solid`,
		borderColor,
		borderRadius: '100px',
		padding: '16px 32px',

		display: 'flex',
		flexFlow: 'row nowrap',
		alignItems: 'center',
		gap: '10px',
		maxWidth: 'none',
		minWidth: 'none',

		fontFamily: 'Integral CF, sans-serif',
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '1.2em',

		'&.Mui-disabled': {
			color: Colors.gray,
		},

		'&:hover': {
			color: transparent ? Colors.white : strictColor ? darken(fontColor, 0.3) : hoverFontColor,
			backgroundColor: transparent
				? Colors.white_a10
				: strictColor
				? darken(backgroundColor, 0.3)
				: hoverBackgroundColor,
		},

		'&:active': {
			color: transparent ? Colors.white : strictColor ? darken(fontColor, 0.35) : activeFontColor,
			backgroundColor: transparent
				? Colors.white_a10
				: strictColor
				? darken(backgroundColor, 0.35)
				: activeBackgroundColor,
		},
	};
};
